/**
 * Remote Monitoring Constants
 * Centralized constants for the Remote Monitoring feature
 */

// Gateway monitoring statuses
export const GATEWAY_STATUS = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    STARTING: 'STARTING',
    PAUSING: 'PAUSING',
    STOPPING: 'STOPPING',
    STOPPED: 'STOPPED',
    INACTIVE: 'INACTIVE'
};

// Array of statuses that indicate active monitoring is in progress
export const ACTIVE_MONITORING_STATUSES = [
    GATEWAY_STATUS.ACTIVE,
    GATEWAY_STATUS.PAUSED,
    GATEWAY_STATUS.STARTING,
    GATEWAY_STATUS.PAUSING,
    GATEWAY_STATUS.STOPPING
];

// URL parameter names
export const URL_PARAMS = {
    MODAL: 'modal',
    STEP: 'step',
    GATEWAY_ID: 'gateway_id'
};

// Modal type identifier
export const MODAL_TYPE = {
    REMOTE_MONITORING: 'rm',
    EXPORTS: 'exports'
};

// Remote Monitoring workflow steps
export const RM_STEPS = {
    SELECT_GATEWAY: 'SELECT_GATEWAY',
    ADD_PATIENT: 'ADD_PATIENT',
    SELECT_PATIENT: 'SELECT_PATIENT',
    CONFIRM_MONITORING: 'CONFIRM_MONITORING',
    MONITORING: 'MONITORING'
};
